import React from 'react'
import { i18n } from '../../index'
import Button from '@mui/material/Button'
import ShiftResponsibilityTable from './ShiftResponsibilityTable'
import ShiftResponsibilityDialog from './ShiftResponsibilityDialog'
import type { ShiftResponsibility } from '../../shiftResponsibility/shiftResponsibilityTypes'
import css from '../incentiveProduct/incentiveProductPage.css'
import withUser from '../../auth/withUser'
type Props = {
  data: Array<ShiftResponsibility>
  stationId?: string
}
type State = {
  isDialogOpen: boolean
  data: ShiftResponsibility | null | undefined
}

@withUser
class ShiftResponsibilityPage extends React.PureComponent<Props, State> {
  state = {
    isDialogOpen: false,
    data: null,
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      data: null,
    })
  }
  onEdit = (data: ShiftResponsibility) => {
    this.setState({
      data,
    })
    this.openDialog()
  }

  render() {
    const { data: shiftResponsibilities, stationId } = this.props
    const { isDialogOpen, data } = this.state
    return (
      <div className={css.component}>
        <ShiftResponsibilityTable data={shiftResponsibilities} stationId={stationId} onEdit={this.onEdit} />
        <div className={css.bottom}>
          <Button onClick={this.openDialog} variant='contained' color='primary'>
            {i18n.t('buttons.create')}
          </Button>
        </div>
        <ShiftResponsibilityDialog data={data} stationId={stationId} isOpen={isDialogOpen} onClose={this.closeDialog} />
      </div>
    )
  }
}

export default ShiftResponsibilityPage
